/*
 * author: Michael Bauer (Geoplex)
 * email:  michael.bauer@geoplex.com.au
 *
 */

import { subclass, property } from "@arcgis/core/core/accessorSupport/decorators";
import Widget from "@arcgis/core/widgets/Widget";
import { tsx } from "@arcgis/core/widgets/support/widget";


import { getLayer, Layer } from "./layers"
import { loadLayerControlPanel } from './widgetbuilder'

import { appConfig, refreshTimeSlider } from "./main"

const CSS = {
  base: "layerselector"
};

interface string_map {
    [key: string]: number
}

@subclass("esri.widgets.LayerSelector")
class LayerSelector extends Widget {

    @property()
    layerIds: string[] = []

    @property()
    filteredLayerIds: string[] = []

    @property()
    allowMany: boolean = true

    panel: string = '';

    filterTextId: string = '';

    slider_values: string_map = {};

    constructor(params: any){
        super(params);
        this.goToControls = this.goToControls.bind(this)
        this.setLayerVisible = this.setLayerVisible.bind(this)
        this.setLayerInVisible = this.setLayerInVisible.bind(this)
        this.opacityChange = this.opacityChange.bind(this)
        this.filter = this.filter.bind(this)
    }

    postInitialize() {
        for (let layerid of this.layerIds) {
            const layer = getLayer(layerid)

            if(!layer) continue;
            if(layer.id == null) continue;

            $('input[name=' + layer.id + ']').val(layer.esriLayer?.opacity ?? 0)

            this.slider_values[layer.id] = Math.floor(Math.random() * 1000)
        }

        this.filteredLayerIds = this.layerIds

        this.filterTextId = "layer-filter-text" + Math.floor(Math.random() * 1000).toString()
    }

    filter(e: any) {
        
        if ($('#' + this.filterTextId).val()) {
            this.filteredLayerIds = []
            for (let layerid of this.layerIds) {
                const layer = getLayer(layerid);

                if(!layer) continue;

                // console.log("Checking " + layer.name?.toUpperCase() + " for " + $('#' + this.filterTextId).val())

                if (layer.name && layer.name.toUpperCase().indexOf(($('#' + this.filterTextId).val() as string).toUpperCase() ) >= 0) {
                    this.filteredLayerIds.push(layerid)
                    // console.log("Adding!")
                }
            }
        } else {
            this.filteredLayerIds = this.layerIds
        }
        // console.log("Printing all filtered messages")
        // console.log(this.filteredLayerIds)
    }

    goToControls(e: any){
        const layer = getLayer($(e.target)?.attr('name'));

        if(!layer) return;

        loadLayerControlPanel(layer, this.panel)

        // @ts-ignore
        $("#dynamiclayers").collapse('hide');
        // @ts-ignore
        $("#contextlayers").collapse('hide');
        // @ts-ignore
        $("#layercontrols").collapse('show');
        // @ts-ignore
        $('#collapsecontrols').collapse('show')

    }

    setLayerVisible(e: any){
        if(!this.allowMany){
            for(let layerid of this.layerIds){
                const layer = getLayer(layerid)
                if(layer?.esriLayer)
                    layer.esriLayer.visible = false
            }
        }
        const layer = getLayer($(e.target)?.attr('name'));

        if(layer?.esriLayer)
            layer.esriLayer.visible = true
        layer?.onSelect()

        refreshTimeSlider()
    }

    setLayerInVisible(e: any){
        const layer = getLayer($(e.target)?.attr('name'));
        if(layer?.esriLayer)
        layer.esriLayer.visible = false
    }

    opacityChange(e: any) {
        const layer = getLayer($(e.target)?.attr('name'));
        if(layer?.esriLayer)
        layer.esriLayer.opacity = parseFloat($(e.target).val() as string)
    }

    render() {
        let layerHTMLObjects = []
        let layer : Layer | null = null

        let visibilityIcon, contolsLink


        for (let layerid of this.filteredLayerIds){
            layer = getLayer(layerid)

            if(!layer) continue;
            if(layer.id == null) continue;

            if (layer.esriLayer && layer.esriLayer.visible){
                visibilityIcon = <span name={ layer.id } style="font-size: 20px; margin-top: auto;" class="esri-icon-visible" onclick={this.setLayerInVisible}></span>
            } else {
                visibilityIcon = <span name={ layer.id } style="font-size: 20px; margin-top: auto;" class="esri-icon-non-visible" onclick={this.setLayerVisible}></span>
            }

            if(layer.controls && layer.controls.length > 0){
                contolsLink = <span name={ layer.id } style="font-size: 20px; margin-top: auto;" class="esri-icon-configure-popup" onclick={this.goToControls}></span>
            } else {
                contolsLink = <span></span>
            }

            layerHTMLObjects.push(
                <div class="row" id={layer.id} key={this.slider_values[layer.id]}>
                    <div class="row row-no-margin">
                        <div class="col-md-2">
                            { visibilityIcon }
                        </div>

                        <div class="col-md-10">
                            <h5 style="margin-top: 0px;">{ layer.name }</h5>
                        </div>
                    </div>
                    <div class="row row-no-margin">
                        <div class="col-md-2">
                            { contolsLink }
                        </div>
                        <div class="col-md-10">
                            <p style="font-size: small;">{ layer.desc }</p>
                        </div>
                    </div>
                    <div class="row row-no-margin">
                        <div class="col-md-2">
                            <span>{Math.floor((layer.esriLayer?.opacity ?? 0) * 100)}%</span>
                        </div>
                        <div class="col-md-10">
                            <div class="slider-labels">
                                <span></span><span style="font-size: small">Opacity</span><span></span>
                            </div>
                            <input name={layer.id} oninput={this.opacityChange} class="calcite-slider" type="range"
                                min="0" max="1" step="0.01" value={layer.esriLayer?.opacity ?? 0 } style="width: 100%;" />
                        </div>
                    </div>
                    <hr></hr>
                </div>
                
            )
        }

        return (
            <div class={this.classes(CSS.base)}>
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col-md-12">
                        <label for={this.filterTextId}>
                            Filter Layers:
                            <div class="input-group">
                                <input type="text" id={this.filterTextId} oninput={this.filter} class="form-control"></input>
                                <span class="input-group-btn">
                                    <button class="btn btn-default" onclick={this.filter} type="button">
                                        <span class="esri-icon-search"></span>&nbsp;
                                    </button>
                                </span>
                            </div>
                        </label>
                    </div>
                </div>

                { layerHTMLObjects }
            </div>
        );
    }
}

export default LayerSelector